import { faCheck, faLocationDot, faPlus, faTimes, faTruckFast, faUndo, faUser } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useCallback, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Input } from "../../components/Input"
import { Load } from "../../components/Load"
import { ICidades, IEntregas, IEntregasCidades, IEntregasFreelancer, IPessoas, IVeiculos } from "../../global/types"
import { useAdmContext } from "../../hooks/useAdmContext"
import { api } from "../../services/api"
import Modal from "react-modal"
import "./style.css"
import { defaultModalStyle } from "../../utils/defaultModalStyle"
import { VeiculosModal } from "../../modals/VeiculosModal"
import { PessoasModal } from "../../modals/PessoasModal"
import { maskNumber } from "../../utils/masks"
import { CidadesModal } from "../../modals/CidadesModal"
import { convertDateSqlToDate, convertDateToBr, convertToUs, convertToUTC, dateNow } from "../../utils/dateProvider"
import { currencyFormatter } from "../../utils/currencyFormatter"

type ParamsProps = {
  tipo: "new" | "edit"
}

type IParams = {
  id: string
}

export function EntregasForm({ tipo }: ParamsProps) {
  const navigate = useNavigate()

  const { id } = useParams() as IParams
  const { tokens, checkToken, usuario } = useAdmContext()

  const [loading, setLoading] = useState(false)
  const [txtLoading, setTxtLoading] = useState("")

  const [cadastro, setCadastro] = useState<IEntregas>({} as IEntregas)
  const [tempCidades, setTempCidades] = useState<IEntregasCidades[]>([])
  const [tempFreelancers, setTempFreelancers] = useState<IEntregasFreelancer[]>([])

  const [listCadCidades, setListCadCidades] = useState<IEntregasCidades[]>([])
  const [listCadFreelancers, setListCadFreelancers] = useState<IEntregasFreelancer[]>([])

  const [cidadeSelected, setCidadeSelected] = useState<ICidades>({} as ICidades)
  const [freelancerSelected, setFreelancerSelected] = useState<IPessoas>({} as IPessoas)
  const [funcaoFreelancer, setFuncaoFreelancer] = useState(0)

  const [modalVeiculo, setModalVeiculo] = useState(false)
  const [modalMotorista, setModalMotorista] = useState(false)
  const [modalAjudante, setModalAjudante] = useState(false)
  const [modalCidades, setModalCidades] = useState(false)
  const [modalFreelancer, setModalFreelancer] = useState(false)

  const handleSelectVeiculo = (veiculo: IVeiculos) => {
    setCadastro(e => ({ ...e, veiculo }))
    setCadastro(e => ({ ...e, km_inicial: veiculo.km }))
  }

  const handleSelectMotorista = (motorista: IPessoas) => {
    setCadastro(e => ({ ...e, motorista }))
  }

  const handleSelectAjudante = (ajudante: IPessoas) => {
    setCadastro(e => ({ ...e, ajudante }))
  }

  const handleAddCidadeTemp = () => {
    if (!cidadeSelected.id)
      return

    if (tempCidades.filter(e => e.id_cidade === cidadeSelected.id).length > 0)
      return alert("Cidade já adicionada")

    if (listCadCidades.filter(e => e.id_cidade === cidadeSelected.id).length > 0)
      return alert("Cidade já adicionada")

    const temp: IEntregasCidades = {
      id_cidade: `${cidadeSelected.id}`,
      cidade: cidadeSelected
    }

    setTempCidades(e => ([
      temp,
      ...e
    ]))

    setCidadeSelected({} as ICidades)
  }

  const handleAddFreelancerTemp = () => {
    if (!freelancerSelected.id)
      return

    if (tempFreelancers.filter(e => e.id_pessoa === freelancerSelected.id).length > 0)
      return alert("Pessoa já adicionado")

    if (listCadFreelancers.filter(e => e.id_pessoa === freelancerSelected.id).length > 0)
      return alert("Pessoa já adicionado")

    if (cadastro.motorista?.id && freelancerSelected.id === cadastro.motorista.id)
      return alert("Pessoa inserida como Motorista")

    if (cadastro.ajudante?.id && freelancerSelected.id === cadastro.ajudante.id)
      return alert("Pessoa inserida como Ajudante")

    const temp: IEntregasFreelancer = {
      id_pessoa: `${freelancerSelected.id}`,
      pessoa: freelancerSelected,
      funcao: funcaoFreelancer
    }

    setTempFreelancers(e => ([
      temp,
      ...e
    ]))

    setFreelancerSelected({} as IPessoas)
  }

  const handleDeleteTempCidade = (item: IEntregasCidades) => {
    if (!window.confirm(`Deseja realmente excluir ${item.cidade.nome} da lista?`))
      return

    const newList: IEntregasCidades[] = []

    tempCidades.forEach((rs) => {
      if (rs.id_cidade !== item.id_cidade)
        newList.push(rs)
    })

    setTempCidades(newList)
  }

  const handleDeleteTempFreelancer = (item: IEntregasFreelancer) => {
    if (!window.confirm(`Deseja realmente excluir ${item.pessoa.nome} da lista?`))
      return

    const newList: IEntregasFreelancer[] = []

    tempFreelancers.forEach((rs) => {
      if (rs.id_pessoa !== item.id_pessoa)
        newList.push(rs)
    })

    setTempFreelancers(newList)
  }

  const handleDeleteCidade = async (item: IEntregasCidades) => {
    if (!window.confirm(`Deseja realmente excluir ${item.cidade.nome}? Essa ação será feita sem a necessidade de clicar em salvar`))
      return

    setLoading(true)
    setTxtLoading(`Excluindo ${item.cidade.nome} da lista...`)

    await api.delete("entregas/cidade", {
      data: {
        id: item.id
      }
    })
      .then(() => {
        const newList: IEntregasCidades[] = []

        listCadCidades.forEach(rs => {
          if (item.id !== rs.id)
            newList.push(rs)
        })

        setListCadCidades(newList)
      })
      .catch((err) => {
        if (err.response?.data?.message)
          alert(err.response.data.message)
        else
          alert(`Erro ao excluir ${item.cidade.nome}. Tente novamente mais tarde`)
      })
      .finally(() => {
        setLoading(false)
        setTxtLoading("")
      })
  }

  const handleDeleteFreelancer = async (item: IEntregasFreelancer) => {
    if (!window.confirm(`Deseja realmente excluir ${item.pessoa.nome}? Essa ação será feita sem a necessidade de clicar em salvar`))
      return

    setLoading(true)
    setTxtLoading(`Excluindo ${item.pessoa.nome} da lista...`)

    await api.delete("entregas/freelancer", {
      data: {
        id: item.id
      }
    })
      .then(() => {
        const newList: IEntregasFreelancer[] = []

        listCadFreelancers.forEach(rs => {
          if (item.id !== rs.id)
            newList.push(rs)
        })

        setListCadFreelancers(newList)
      })
      .catch((err) => {
        if (err.response?.data?.message)
          alert(err.response.data.message)
        else
          alert(`Erro ao excluir ${item.pessoa.nome}. Tente novamente mais tarde`)
      })
      .finally(() => {
        setLoading(false)
        setTxtLoading("")
      })
  }

  const loadCadastro = useCallback(async () => {
    setLoading(true)
    setTxtLoading("Carregando cadastro...")

    const canLoad = await checkToken()
    if (!canLoad)
      return

    await api.get(`entregas/${id}`)
      .then((res) => {
        if (!res.data)
          return

        const cad = res.data as IEntregas

        setCadastro({
          ...cad,
          data: convertDateToBr(convertDateSqlToDate(`${cad.data}`)),
          entrada: cad.entrada.toString().substring(0, 5),
          saida: cad.saida ? cad.saida.toString().substring(0, 5) : undefined,
          valor_carga: currencyFormatter(parseFloat(`${cad.valor_carga}`), false),
          valor_diesel: currencyFormatter(parseFloat(`${cad.valor_diesel}`), false),
          diarias: cad.diarias ? currencyFormatter(parseFloat(`${cad.diarias}`), false) : "",
          valor_pedagio: currencyFormatter(parseFloat(`${cad.valor_pedagio}`), false),
          valor_balsa: currencyFormatter(parseFloat(`${cad.valor_balsa}`), false),
          diversos: currencyFormatter(parseFloat(`${cad.diversos}`), false),
          roteiro: maskNumber(`${cad.roteiro}`)
        })

        if (cad.cidades)
          setListCadCidades(cad.cidades)

        if (cad.freelancers)
          setListCadFreelancers(cad.freelancers)

      })
      .catch((err) => {
        if (err.response?.data?.message)
          alert(err.response.data.message)
        else
          alert("Erro ao carregar o cadastro. Tente novamente mais tarde")
      })
      .finally(() => {
        setLoading(false)
        setTxtLoading("")
      })
  }, [checkToken, id])

  const handleSalvar = async () => {

    if (cadastro.ajudante && cadastro.motorista.id === cadastro.ajudante.id)
      return alert("Motorista e Ajudante são a mesma pessoa")

    if (!cadastro.veiculo.id)
      return alert("Selecione um Veículo");

    if (!cadastro.motorista.id)
      return alert("Selecione um Motorista")

    if (`${cadastro.data}`.length !== 10)
      return alert("Informe a data")

    if (cadastro.km_final > 0 && parseInt((`${cadastro.km_final}`).replace(/\D/g, "")) < parseInt((`${cadastro.km_inicial}`).replace(/\D/g, "")))
      return alert("Km final deve ser maior do que o Km inicial")

    if (!cadastro.pedidos || cadastro.pedidos <= 0)
      return alert("Informa a quantidade de pedidos")

    if (`${cadastro.entrada}`.length !== 5)
      return alert("Informe a hora da entrada corretamente")

    if (!cadastro.valor_carga || cadastro.valor_carga === "")
      return alert("Informe o valor da carga")

    if (`${cadastro.saida}`.length === 5 && (!cadastro.km_final || cadastro.km_final <= 0))
      return alert("Preencha o Km Final para finalizar a entrega")

    setLoading(true)
    setTxtLoading("Verificando acesso...")

    const canLoad = await checkToken()
    if (!canLoad)
      return

    try {

      setTxtLoading("Salvando entrega...")
      const reqEntrega = await api.post("entregas", {
        ...cadastro,
        id_veiculo: cadastro.veiculo.id,
        id_motorista: cadastro.motorista.id,
        id_user: usuario?.idUser,
        roteiro: `${cadastro.roteiro}`.replace(/\D/g, ""),
        data: `${convertToUs(`${cadastro.data}`)} 00:00:00`,
        entrada: cadastro.entrada,
        saida: `${cadastro.saida}`.length === 5 ? `${cadastro.saida}` : "00:00:00",
        pedidos: cadastro.pedidos,
        valor_carga: parseFloat((`${cadastro.valor_carga}`).replace(".", "").replace(",", ".")),
        km_inicial: parseInt((`${cadastro.km_inicial}`).replace(/\D/g, "")),
        km_final: cadastro.km_final && cadastro.km_final > 0 ? parseInt((`${cadastro.km_final}`).replace(/\D/g, "")) : 0,
        valor_diesel: cadastro.valor_diesel && cadastro.valor_diesel !== "" ? parseFloat((`${cadastro.valor_diesel}`).replace(".", "").replace(",", ".")) : 0,
        diarias: cadastro.diarias && cadastro.diarias !== "" ? parseFloat((`${cadastro.diarias}`).replace(".", "").replace(",", ".")) : 0,

        salario_motor: `${cadastro.saida}`.length === 5 ? cadastro.motorista.valor_motor : 0,
        extra_motor: `${cadastro.saida}`.length === 5 ? cadastro.motorista.hr_extra_motor : 0,
        carga_motor: `${cadastro.saida}`.length === 5 ? cadastro.motorista.carga_horario : "00:00:00",

        salario_ajud: `${cadastro.saida}`.length === 5 && cadastro.ajudante ? cadastro.ajudante.valor_ajud : 0,
        extra_ajud: `${cadastro.saida}`.length === 5 && cadastro.ajudante ? cadastro.ajudante.hr_extra_motor : 0,
        carga_ajud: `${cadastro.saida}`.length === 5 && cadastro.ajudante ? cadastro.ajudante.carga_horario : "00:00:00",

        valor_balsa: cadastro.valor_balsa && cadastro.valor_balsa !== "" ? parseFloat((`${cadastro.valor_balsa}`).replace(".", "").replace(",", ".")) : 0,
        valor_pedagio: cadastro.valor_pedagio && cadastro.valor_pedagio !== "" ? parseFloat((`${cadastro.valor_pedagio}`).replace(".", "").replace(",", ".")) : 0,
        diversos: cadastro.diversos && cadastro.diversos !== "" ? parseFloat((`${cadastro.diversos}`).replace(".", "").replace(",", ".")) : 0,
      });

      if (!reqEntrega.data)
        throw new Error("Erro ao recuperar entrega salva");

      if (cadastro.km_final > 0) {
        if (parseInt((`${cadastro.km_final}`).replace(/\D/g, "")) > parseInt((`${cadastro.veiculo.km}`).replace(/\D/g, ""))) {
          setTxtLoading("Atualizando Km do veículo")
          await api.post("veiculos", {
            ...cadastro.veiculo,
            km: parseInt((`${cadastro.km_final}`).replace(/\D/g, ""))
          })
        }
      }

      const entrega: IEntregas = reqEntrega.data as IEntregas

      await Promise.allSettled(
        tempCidades.map(async (item, i) => {
          setTxtLoading(`Salvando lista de cidades ${i + 1}/${tempCidades.length}...`)
          await api.post("entregas/cidade", {
            id_entrega: entrega.id,
            id_cidade: item.id_cidade
          })
        })
      )

      await Promise.allSettled(
        tempFreelancers.map(async (item, i) => {
          setTxtLoading(`Salvando lista de freelancers ${i + 1}/${tempFreelancers.length}...`)
          await api.post("entregas/freelancer", {
            id_entrega: entrega.id,
            id_pessoa: item.id_pessoa,
            funcao: item.funcao,
          })
        })
      )

      if (`${cadastro.saida}`.length >= 2) {
        const dbFreelancers = await api.get(`entregas/freelancers?id=${entrega.id}`)

        if (dbFreelancers.data) {
          const listFree = dbFreelancers.data.result as IEntregasFreelancer[]

          await Promise.allSettled(
            listFree.map(async (item, i) => {
              setTxtLoading(`Salvando salário dos Ajudantes/Freelancers ${i + 1}/${dbFreelancers.data.total}...`)
              await api.post("entregas/freelancer", {
                ...item,
                salario: item.funcao === 0 ? item.pessoa.valor_ajud : item.pessoa.valor_freelancer,
                extra: item.funcao === 0 ? item.pessoa.hr_extra_ajud : 0,
                carga_hr: item.funcao === 0 ? item.pessoa.carga_horario : "00:00:00",
              })
            })
          )
        }
      }

      navigate("/entregas");

    } catch (err: any) {
      console.log(err);

      if (err.response?.data?.message)
        alert(err.response.data.message);
      else
        alert("Erro ao salvar. Tente novamente mais tarde.");
    }
    finally {
      setLoading(false)
      setTxtLoading("")
    }
  }

  useEffect(() => {
    if (tokens?.token && tipo === "edit")
      loadCadastro()
    else
      setCadastro(e => ({ ...e, data: convertDateToBr(dateNow()) }))
  }, [tokens, tipo, loadCadastro])

  useEffect(() => {
    Modal.setAppElement("body")
  }, [])

  return (
    <div id="pgEtregasForm">

      {loading && (
        <Load txtLoading={txtLoading} />
      )}

      {!loading && (
        <>
          <div className="painel form">
            <p className="title">{tipo === "new" ? "Novo" : "Editando"} Cadastro</p>

            <div style={{ width: "32%" }}>
              <label>Roteiro</label>
              <Input
                mask="number"
                value={`${cadastro.roteiro ? maskNumber(`${cadastro.roteiro}`) : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, roteiro: v }))}
                placeholder="0"
                type="tel"
              />
            </div>

            <div style={{ width: "32%" }} >
              <label>Veículo:</label>
              <span className="dvFilterSelect">
                <Input
                  mask="none"
                  value={cadastro.veiculo?.nome ? cadastro.veiculo.nome : ""}
                  inputMaskChange={(v) => { }}
                  readOnly
                />
                {cadastro.veiculo?.nome && (
                  <button className="btn-red" onClick={() => setCadastro(e => ({ ...e, veiculo: {} as IVeiculos }))}>
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                )}

                <button className="btn-purple" onClick={() => setModalVeiculo(true)}>
                  <FontAwesomeIcon icon={faTruckFast} />
                </button>
              </span>
            </div>

            <div style={{ width: "32%" }}>
              <label>Motorista:</label>
              <span className="dvFilterSelect">
                <Input
                  mask="none"
                  value={cadastro.motorista?.nome ? cadastro.motorista.nome : ""}
                  inputMaskChange={(v) => { }}
                  readOnly
                />
                {cadastro.motorista?.nome && (
                  <button className="btn-red" onClick={() => setCadastro(e => ({ ...e, motorista: {} as IPessoas }))}>
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                )}

                <button className="btn-purple" onClick={() => setModalMotorista(true)}>
                  <FontAwesomeIcon icon={faUser} />
                </button>
              </span>
            </div>

            <div style={{ width: "32%" }}>
              <label>Data</label>
              <Input
                mask="date"
                value={cadastro.data ? `${cadastro.data}` : ""}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, data: v }))}
                placeholder="00/00/0000"
                maxLength={10}
              />
            </div>

            <div style={{ width: "32%" }}>
              <label>Entrada</label>
              <Input
                mask="none"
                value={cadastro.entrada ? `${cadastro.entrada}` : ""}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, entrada: v }))}
                type="time"
                maxLength={5}
              />
            </div>

            <div style={{ width: "32%" }}>
              <label>Km Inicial</label>
              <Input
                mask="number"
                value={`${cadastro.km_inicial ? maskNumber(`${cadastro.km_inicial}`) : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, km_inicial: v }))}
                placeholder="0"
                type="tel"
              />
            </div>

            <div style={{ width: "32%" }}>
              <label>Qtd Pedidos</label>
              <Input
                mask="number"
                value={cadastro.pedidos ? `${cadastro.pedidos}` : ""}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, pedidos: parseInt(v) }))}
                placeholder="0"
                min={0}
                type="number"
              />
            </div>

            <div style={{ width: "32%" }}>
              <label>Valor da Carga</label>
              <Input
                mask="currency"
                value={`${cadastro.valor_carga ? cadastro.valor_carga : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, valor_carga: v }))}
                placeholder="0,00"
                type="tel"
              />
            </div>

            <div style={{ width: "32%" }}>
              <label>Valor do Diesel</label>
              <Input
                mask="currency"
                value={`${cadastro.valor_diesel ? cadastro.valor_diesel : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, valor_diesel: v }))}
                placeholder="0,00"
                type="tel"
              />
            </div>

            <div style={{ width: "32%" }}>
              <label>Diária por Pessoa</label>
              <Input
                mask="currency"
                value={`${cadastro.diarias ? cadastro.diarias : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, diarias: v }))}
                placeholder="0,00"
                type="tel"
              />
            </div>

            <div style={{ width: "32%" }}>
              <label>Saída</label>
              <Input
                mask="none"
                value={cadastro.saida && cadastro.saida !== "00:00" ? `${cadastro.saida}` : ""}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, saida: v }))}
                type="time"
                maxLength={5}
              />
            </div>

            <div style={{ width: "32%" }}>
              <label>Km Final</label>
              <Input
                mask="number"
                value={`${cadastro.km_final ? maskNumber(`${cadastro.km_final}`) : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, km_final: v }))}
                placeholder="0"
                type="tel"
              />
            </div>

            <div style={{ width: "32%" }}>
              <label>Valor do Pedágio</label>
              <Input
                mask="currency"
                value={`${cadastro.valor_pedagio ? cadastro.valor_pedagio : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, valor_pedagio: v }))}
                placeholder="0,00"
                type="tel"
              />
            </div>

            <div style={{ width: "32%" }}>
              <label>Valor da Balsa</label>
              <Input
                mask="currency"
                value={`${cadastro.valor_balsa ? cadastro.valor_balsa : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, valor_balsa: v }))}
                placeholder="0,00"
                type="tel"
              />
            </div>

            <div style={{ width: "32%" }}>
              <label>Gastos Diversos</label>
              <Input
                mask="currency"
                value={`${cadastro.diversos ? cadastro.diversos : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, diversos: v }))}
                placeholder="0,00"
                type="tel"
              />
            </div>

          </div>

          <div className="painel form">
            <p className="title">Cidades</p>

            <div style={{ width: "32%" }} >
              <label>Cidade:</label>
              <span className="dvFilterSelect">
                <Input
                  mask="none"
                  value={cidadeSelected.nome ? cidadeSelected.nome : ""}
                  inputMaskChange={(v) => { }}
                  placeholder="Selecione uma cidade"
                  readOnly
                />
                {cidadeSelected.nome && (
                  <button className="btn-red" onClick={() => setCidadeSelected({} as ICidades)}>
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                )}

                <button className="btn-purple" onClick={() => setModalCidades(true)}>
                  <FontAwesomeIcon icon={faLocationDot} />
                </button>
              </span>
            </div>

            <span>
              <button className="btn-green" style={{ height: "45px", marginTop: "19px" }} onClick={() => handleAddCidadeTemp()}>
                <FontAwesomeIcon icon={faPlus} />
                Adicionar
              </button>
            </span>

            <div className="head">
              <span style={{ width: "50px" }}></span>
              <span style={{ flex: '1' }}>Cidade</span>
            </div>

            <div className="tableContent">
              {tempCidades && tempCidades.map(item => (
                <div className="rowTable" key={item.id_cidade}>
                  <button className="btn-red btnSmall" onClick={() => handleDeleteTempCidade(item)}>
                    <FontAwesomeIcon icon={faTimes} />
                  </button>

                  <span style={{ flex: '1' }}>{item.cidade.nome}</span>

                </div>
              ))}

              {listCadCidades && listCadCidades.filter(e => !e.excluir).map(item => (
                <div className="rowTable" key={item.id_cidade}>
                  <button className="btn-red btnSmall" onClick={() => handleDeleteCidade(item)}>
                    <FontAwesomeIcon icon={faTimes} />
                  </button>

                  <span style={{ flex: '1' }}>{item.cidade.nome}</span>

                </div>
              ))}
            </div>

          </div>

          <div className="painel form">
            <p className="title">Ajudantes / Freelancers</p>

            <div style={{ width: "32%" }} >
              <label>Pessoa:</label>
              <span className="dvFilterSelect">
                <Input
                  mask="none"
                  value={freelancerSelected.nome ? freelancerSelected.nome : ""}
                  inputMaskChange={(v) => { }}
                  placeholder="Selecione um freelancer"
                  readOnly
                />
                {freelancerSelected.nome && (
                  <button className="btn-red" onClick={() => setFreelancerSelected({} as IPessoas)}>
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                )}

                <button className="btn-purple" onClick={() => setModalFreelancer(true)}>
                  <FontAwesomeIcon icon={faUser} />
                </button>
              </span>
            </div>

            <div style={{ width: "20%" }}>
              <label>Função:</label>
              <select value={funcaoFreelancer} onChange={(e) => setFuncaoFreelancer(parseInt(e.target.value))}>
                <option value="0">Ajudante</option>
                <option value="1">Freelancer</option>
              </select>
            </div>

            <span>
              <button className="btn-green" style={{ height: "45px", marginTop: "19px" }} onClick={() => handleAddFreelancerTemp()}>
                <FontAwesomeIcon icon={faPlus} />
                Adicionar
              </button>
            </span>

            <div className="head">
              <span style={{ width: "60px" }}></span>
              <span style={{ width: "100px" }}>Função</span>
              <span style={{ flex: '1' }}>Pessoa</span>
            </div>

            <div className="tableContent">
              {tempFreelancers && tempFreelancers.map(item => (
                <div className="rowTable" key={item.id_pessoa}>

                  <button className="btn-red btnSmall" onClick={() => handleDeleteTempFreelancer(item)} style={{ marginRight: "10px" }}>
                    <FontAwesomeIcon icon={faTimes} />
                  </button>

                  <span style={{ width: "100px" }}>{item.funcao === 1 ? "Freelancer" : "Ajudante"}</span>
                  <span style={{ flex: '1' }}>{item.pessoa.nome}</span>

                </div>
              ))}

              {listCadFreelancers && listCadFreelancers.filter(e => !e.excluir).map(item => (
                <div className="rowTable" key={item.id_pessoa}>

                  <button className="btn-red btnSmall" onClick={() => handleDeleteFreelancer(item)} style={{ marginRight: "10px" }}>
                    <FontAwesomeIcon icon={faTimes} />
                  </button>

                  <span style={{ width: "100px" }}>{item.funcao === 1 ? "Freelancer" : "Ajudante"}</span>
                  <span style={{ flex: '1' }}>{item.pessoa.nome}</span>

                </div>
              ))}
            </div>

          </div>

          {cadastro.created_at && (
            <div className="painel form">
              <p className="title" style={{ marginBottom: "10px" }}>Informações de Alteração</p>

              <div style={{ width: "32.3%", textAlign: "center" }} >
                <span><b>Data de criação: </b></span>
                <span>{convertToUTC(convertDateSqlToDate(`${cadastro.created_at}`))}</span>
              </div>

              <div style={{ width: "32.3%", textAlign: "center" }} >
                <span><b>Data da alteração: </b></span>
                <span>{convertToUTC(convertDateSqlToDate(`${cadastro.updated_at}`))}</span>
              </div>

              <div style={{ width: "32.3%", textAlign: "center" }} >
                <span><b>Usuário: </b></span>
                <span>{cadastro.user.nome}</span>
              </div>

            </div>

          )}

          <div className="btnPainel">
            <button className="btn-purple" onClick={() => { navigate(-1) }}>
              <FontAwesomeIcon icon={faUndo} />
              VOLTAR
            </button>

            <button className="btn-green" onClick={() => { handleSalvar() }}>
              <FontAwesomeIcon icon={faCheck} />
              SALVAR
            </button>
          </div>
        </>
      )}

      <Modal isOpen={modalVeiculo} style={defaultModalStyle}>
        <VeiculosModal closeModal={() => setModalVeiculo(false)} handleSelect={(e) => handleSelectVeiculo(e)} />
      </Modal>

      <Modal isOpen={modalMotorista} style={defaultModalStyle}>
        <PessoasModal closeModal={() => setModalMotorista(false)} handleSelect={(e) => handleSelectMotorista(e)} />
      </Modal>

      <Modal isOpen={modalAjudante} style={defaultModalStyle}>
        <PessoasModal closeModal={() => setModalAjudante(false)} handleSelect={(e) => handleSelectAjudante(e)} />
      </Modal>

      <Modal isOpen={modalCidades} style={defaultModalStyle}>
        <CidadesModal closeModal={() => setModalCidades(false)} handleSelect={(e) => setCidadeSelected(e)} />
      </Modal>

      <Modal isOpen={modalFreelancer} style={defaultModalStyle}>
        <PessoasModal closeModal={() => setModalFreelancer(false)} handleSelect={(e) => setFreelancerSelected(e)} />
      </Modal>

    </div>
  )
}